import React from 'react';

const TimepickerDisabled: React.FC = () => {
    return (
        <table className='form-group'>
            <tbody>
                <tr className="text-center">
                    <td><button disabled className="btn btn-link"><div className="sprites sprite-arrow-ivory-up"></div></button></td>
                    <td>&nbsp;</td>
                    <td><button disabled className="btn btn-link"><div className="sprites sprite-arrow-ivory-up"></div></button></td>
                    <td></td>
                </tr>
                <tr className='time-picker-disabled'>
                    <td className="time-picker-width form-group">
                        <input disabled type="text" className="form-control hours-field" />
                    </td>
                    <td>:</td>
                    <td className="time-picker-width form-group">
                        <input disabled type="text" className="form-control minutes-field" />
                    </td>
                    <td className="time-picker-width"><button disabled type="button" className="btn btn-default">AM</button></td>
                </tr>
                <tr className="text-center">
                    <td><button disabled className="btn btn-link"><div className="sprites sprite-arrow-ivory-down"></div></button></td>
                    <td>&nbsp;</td>
                    <td><button disabled className="btn btn-link"><div className="sprites sprite-arrow-ivory-down"></div></button></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    );
};

export default TimepickerDisabled;